/**
 * When a primary Where to Buy (PriceSpider) widget resolves to "No Sellers Found",
 * PriceSpider adds `ps-disabled` to the widget button. In that case we hide the
 * Where to Buy buttons without changing the product's merchandising state.
 */
(function () {
  const PRIMARY_SELECTOR = '[data-wtb-primary]';
  const BUTTON_SELECTOR = '[data-where-to-buy-button]';

  const state = { active: false, ready: false };

  let observer = null;
  let scanTimer = null;

  function hasNoSellers(button) {
    if (!button || !button.isConnected) return false;
    if (button.classList.contains('ps-disabled')) return true;
    if (button.closest('.ps-disabled')) return true;
    const noWtb = button.querySelector('.no-wtb');
    return !!noWtb && getComputedStyle(noWtb).display !== 'none';
  }

  function isResolved(button) {
    if (!button || !button.isConnected) return false;
    if (button.classList.contains('ps-enabled') || button.classList.contains('ps-disabled')) return true;
    if (button.closest('.ps-enabled, .ps-disabled')) return true;
    return button.hasAttribute('aria-disabled');
  }

  function getButtons() {
    return [...document.querySelectorAll(BUTTON_SELECTOR)];
  }

  function resetButton(button) {
    button.removeAttribute('data-wtb-ready');
    button.removeAttribute('data-hidden-by-no-sellers');
    button.classList.add('!hidden');
    button.setAttribute('data-hidden-by-wtb-loading', 'true');
  }

  function keepPendingButtonsHidden() {
    getButtons().forEach((el) => {
      if (el.hasAttribute('data-wtb-ready')) return;
      if (el.hasAttribute('data-hidden-by-no-sellers')) return;
      if (el.hasAttribute('data-hidden-by-wtb-loading')) return;
      el.classList.add('!hidden');
      el.setAttribute('data-hidden-by-wtb-loading', 'true');
    });
  }

  function revealResolvedButtons() {
    getButtons().forEach((el) => {
      if (!isResolved(el)) return;
      el.classList.remove('!hidden');
      el.removeAttribute('data-hidden-by-wtb-loading');
      el.setAttribute('data-wtb-ready', 'true');
    });
  }

  function hideWhereToBuyButtons() {
    getButtons().forEach((el) => {
      if (el.hasAttribute('data-hidden-by-no-sellers')) return;
      el.classList.add('!hidden');
      el.removeAttribute('data-hidden-by-wtb-loading');
      el.setAttribute('data-hidden-by-no-sellers', 'true');
    });
  }

  function restoreWhereToBuyButtons() {
    document.querySelectorAll('[data-hidden-by-no-sellers]').forEach((el) => {
      el.removeAttribute('data-hidden-by-no-sellers');
    });

    revealResolvedButtons();
  }

  function enforce() {
    keepPendingButtonsHidden();

    if (!state.ready) return;

    if (state.active) {
      hideWhereToBuyButtons();
      return;
    }

    restoreWhereToBuyButtons();
  }

  function scan() {
    const primaries = [...document.querySelectorAll(PRIMARY_SELECTOR)];
    const buttons = getButtons();

    state.ready = primaries.length
      ? primaries.every(isResolved)
      : buttons.some(isResolved);
    state.active = primaries.some(hasNoSellers);

    enforce();
  }

  function scheduleScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 100);
  }

  function startObserver() {
    if (observer) observer.disconnect();

    observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const target = mutation.target;
        if (!(target instanceof Element)) continue;

        if (mutation.type === 'attributes' && mutation.attributeName === 'ps-sku' && target.matches?.(BUTTON_SELECTOR)) {
          resetButton(target);
          scheduleScan();
          return;
        }

        if (
          target.matches?.(PRIMARY_SELECTOR) ||
          target.closest?.(PRIMARY_SELECTOR) ||
          target.classList?.contains('ps-disabled') ||
          target.classList?.contains('ps-enabled') ||
          target.matches?.(BUTTON_SELECTOR) ||
          target.closest?.(BUTTON_SELECTOR) ||
          target.querySelector?.(PRIMARY_SELECTOR)
        ) {
          scheduleScan();
          return;
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'aria-disabled', 'ps-sku'],
      childList: true,
      subtree: true,
    });
  }

  function init() {
    scan();
    startObserver();
  }

  window.theme = window.theme || {};
  window.theme.initWhereToBuyNoSellers = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // PriceSpider resolves sellers asynchronously and can re-render after load.
  window.addEventListener('load', () => {
    scan();
    setTimeout(scan, 1000);
    setTimeout(scan, 2500);
    setTimeout(scan, 5000);
  });
})();
